export class GeneralSendingModel {
  nonInstallableSensors: {
    type: string;
    sensorName: string;
    reason: string;
  }[] = [];

  type: string;

  generalComment: string;
  installationComment: string;

  constructor() {
  }

  public static initialize(model: GeneralSendingModel): void {
    if (!model.nonInstallableSensors) {
      model.nonInstallableSensors = [];
    }
  }
}
